<style scope>
  .w-full { width: 100% }
  /*.column {padding-top: 0px}*/
</style>

<template>
  <section class="container">
    <portal-box>
      <b-loading :is-full-page="true" :active.sync="loadingForm"></b-loading>
      <h1 slot="titulo" class="title">Novo prospect</h1>

      <template slot="menu">
        <b-tag size="is-large">{{prospect.DATA_CADASTRO | moment('DD/MM/YYYY')}}</b-tag>
      </template>

      <portal-box class="m-b-md">
        <h1 slot="titulo" class="subtitle">Informações básicas</h1>

        <div class="columns">
          <div class="column">
            <b-field label="CNPJ*"
                     :type="$errorType('CNPJ', errors)"
                     :message="errors.first('CNPJ')">
              <b-input v-model="prospect.CNPJ" name="CNPJ" ref="cnpj"
                       @keyup.enter.native="$refs.razao.focus"
                       data-vv-as="CNPJ" v-validate="'required|min:18|cnpj'" v-mask="'##.###.###/####-##'">
              </b-input>
            </b-field>
          </div>
          <div class="column is-5">
            <b-field label="Razão social*"
                     :type="$errorType('RAZAO', errors)"
                     :message="errors.first('RAZAO')">
              <b-input v-model="prospect.RAZAO" name="RAZAO" ref="razao" maxlength="70"
                       @keyup.enter.native="$refs.fantasia.focus" :hasCounter="false"
                       data-vv-as="Razão social" v-validate="{ rules: { required: true, regex:  /^[a-zA-Z0-9_&\-\s]+$/} }">
              </b-input>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Nome fantasia*"
                     :type="$errorType('FANTASIA', errors)"
                     :message="errors.first('FANTASIA')">
              <b-input v-model="prospect.FANTASIA" name="FANTASIA" ref="fantasia" maxlength="40"
                       @keyup.enter.native="$refs.inscEstadual.focus" :hasCounter="false"
                       data-vv-as="Nome fantasia" v-validate="{ rules: { required: true, regex:  /^[a-zA-Z0-9_&\-\s]+$/} }">
              </b-input>
            </b-field>
          </div>
        </div>

        <div class="columns">
        <div class="column is-2">
          <b-field label="Inscrição estadual"
                   :type="$errorType('INSC_ESTADUAL', errors)"
                   :message="errors.first('INSC_ESTADUAL')">
            <b-input v-model="prospect.INSC_ESTADUAL" name="INSC_ESTADUAL" ref="inscEstadual" maxlength="16"
                     @keyup.enter.native="$refs.suframa.focus" :hasCounter="false"
                     data-vv-as="Inscrição estadual"
                     v-validate="parametros.EMPRESA_NOME === 'ISERO' ? { rules: { regex:  /^[a-zA-Z0-9_\-\s]+$/, required: true} } : { rules: { regex:  /^[a-zA-Z0-9_\-\s]+$/} }">
            </b-input>
          </b-field>
        </div>

        <div class="column is-2">
          <b-field label="Suframa"
                   :type="$errorType('SUFRAMA', errors)"
                   :message="errors.first('SUFRAMA')">
            <b-input v-model="prospect.SUFRAMA" name="SUFRAMA" ref="suframa" maxlength="16"
                     @keyup.enter.native="$refs.telefone.focus" :hasCounter="false"
                     data-vv-as="Suframa" v-validate="{ rules: { regex:  /^[a-zA-Z0-9_\-\s]+$/} }">
            </b-input>
          </b-field>
        </div>

        <div class="column is-2">
          <b-field label="Telefone*"
                   :type="$errorType('TEL', errors)"
                   :message="errors.first('TEL')">
            <b-input v-model="prospect.TEL" name="TEL" ref="telefone" maxlength="15" minlength="14"
                     @keyup.enter.native="$refs.contato.focus" :hasCounter="false" v-mask="['(##) ####-####', '(##) #####-####']"
                     data-vv-as="Telefone" v-validate="'required|min:14'">
            </b-input>
          </b-field>
        </div>

        <div class="column is-2">
          <b-field label="Contato*"
                   :type="$errorType('CONTATO', errors)"
                   :message="errors.first('CONTATO')">
            <b-input v-model="prospect.CONTATO" name="CONTATO" ref="contato" maxlength="50"
                     @keyup.enter.native="$refs.email.focus" :hasCounter="false"
                     data-vv-as="Contato" v-validate="{ rules: { required: true, regex:  /^[a-zA-Z0-9_\-\s]+$/} }">
            </b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Email*"
                   :type="$errorType('EMAIL', errors)"
                   :message="errors.first('EMAIL')">
            <b-input v-model="prospect.EMAIL" name="EMAIL" ref="email" maxlength="70"
                     @keyup.enter.native="$refs.endereco.focus" :hasCounter="false"
                     data-vv-as="Email" v-validate="'required|email'">
            </b-input>
          </b-field>
        </div>
      </div>

      </portal-box>

      <portal-box class="m-b-md">
        <h1 slot="titulo" class="subtitle">Endereço</h1>

        <div class="columns">

          <div class="column is-8">
            <b-field label="Logradouro*"
                     :type="$errorType('ENDERECO', errors)"
                     :message="errors.first('ENDERECO')">
              <b-input v-model="prospect.ENDERECO" name="ENDERECO" ref="endereco" maxlength="70"
                       @keyup.enter.native="$refs.bairro.focus" :hasCounter="false"
                       data-vv-as="Logradouro" v-validate="{ rules: { required: true, regex:  /^[a-zA-Z0-9,_\-\s]+$/} }">
              </b-input>
            </b-field>
          </div>

          <div class="column is-4">
            <b-field label="Bairro*"
                     :type="$errorType('BAIRRO', errors)"
                     :message="errors.first('BAIRRO')">
              <b-input v-model="prospect.BAIRRO" name="BAIRRO" ref="bairro" maxlength="50"
                       @keyup.enter.native="$refs.cidade.focus" :hasCounter="false"
                       data-vv-as="Bairro" v-validate="{ rules: { required: true, regex:  /^[a-zA-Z0-9_\-\s]+$/} }">
              </b-input>
            </b-field>
          </div>

        </div>

        <div class="columns">
          <div class="column is-6">
            <b-field label="Cidade*"
                     :type="$errorType('CIDADE', errors)"
                     :message="errors.first('CIDADE')">
              <b-input v-model="prospect.CIDADE" name="CIDADE" ref="cidade" maxlength="50"
                       @keyup.enter.native="$refs.estado.focus" :hasCounter="false"
                       data-vv-as="Cidade" v-validate="{ rules: { required: true, regex:  /^[a-zA-Z0-9_\-\s]+$/} }">
              </b-input>
            </b-field>
          </div>

          <div class="column is-2">
            <b-field label="UF*"
                     :type="$errorType('ESTADO', errors)"
                     :message="errors.first('ESTADO')">
              <b-select :loading="loadingForm"
                        expanded @keyup.enter.native="$refs.cep.focus"
                        v-model="prospect.ESTADO" name="ESTADO" ref="estado"
                        data-vv-as="UF" v-validate="'required'">
                <option
                  v-for="option in estados"
                  :value="option"
                  :key="option">
                  {{ option }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field label="CEP*"
                     :type="$errorType('CEP', errors)"
                     :message="errors.first('CEP')">
              <b-input v-model="prospect.CEP" name="CEP" ref="cep" maxlength="10" v-mask="'#####-###'"
                       @keyup.enter.native="$refs.ref1.focus" :hasCounter="false"
                       data-vv-as="CEP" v-validate="'required|min:9'">
              </b-input>
            </b-field>
          </div>
        </div>

      </portal-box>

      <portal-box class="m-b-md">
        <h1 slot="titulo" class="subtitle">Referências comerciais</h1>

        <div class="columns">
          <div class="column is-4">
            <b-field label="1ª referência*"
                     :type="$errorType('REF1', errors)"
                     :message="errors.first('REF1')">
              <b-input v-model="prospect.REF1" name="REF1" ref="ref1" maxlength="50"
                       @keyup.enter.native="$refs.telref1.focus" :hasCounter="false"
                       data-vv-as="1ª referência" v-validate="{ rules: { required: true, regex:  /^[a-zA-Z0-9_\-\s]+$/} }">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field label="Telefone(1ª)*"
                     :type="$errorType('TELREF1', errors)"
                     :message="errors.first('TELREF1')">
              <b-input v-model="prospect.TELREF1" name="TELREF1" ref="telref1"
                       @keyup.enter.native="$refs.ref2.focus" :hasCounter="false" v-mask="['(##) ####-####', '(##) #####-####']"
                       data-vv-as="Telefone(1ª)" v-validate="'required|min:14'">
              </b-input>
            </b-field>
          </div>

          <div class="column is-4">
            <b-field label="2ª referência*"
                     :type="$errorType('REF2', errors)"
                     :message="errors.first('REF2')">
              <b-input v-model="prospect.REF2" name="REF2" ref="ref2" maxlength="50"
                       @keyup.enter.native="$refs.telref2.focus" :hasCounter="false"
                       data-vv-as="2ª referência" v-validate="{ rules: { required: true, regex:  /^[a-zA-Z0-9_\-\s]+$/} }">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field label="Telefone(2ª)*"
                     :type="$errorType('TELREF2', errors)"
                     :message="errors.first('TELREF2')">
              <b-input v-model="prospect.TELREF2" name="TELREF2" ref="telref2"
                       @keyup.enter.native="$refs.ref3.focus" :hasCounter="false" v-mask="['(##) ####-####', '(##) #####-####']"
                       data-vv-as="Telefone(2ª)" v-validate="'required|min:14'">
              </b-input>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column is-4">
            <b-field label="3ª referência"
                     :type="$errorType('REF3', errors)"
                     :message="errors.first('REF3')">
              <b-input v-model="prospect.REF3" name="REF3" ref="ref3" maxlength="50"
                       @keyup.enter.native="$refs.telref3.focus" :hasCounter="false"
                       data-vv-as="3ª referência" v-validate="{ rules: { regex:  /^[a-zA-Z0-9_\-\s]+$/} }">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field label="Telefone(3ª)"
                     :type="$errorType('TELREF3', errors)"
                     :message="errors.first('TELREF3')">
              <b-input v-model="prospect.TELREF3" name="TELREF3" ref="telref3"
                       :hasCounter="false" v-mask="['(##) ####-####', '(##) #####-####']"
                       data-vv-as="Telefone(3ª)" v-validate="'min:14'">
              </b-input>
            </b-field>
          </div>
        </div>

      </portal-box>

      <footer class="has-text-right">
        <button type="button" class="button is-medium" @click="cancelar" :class="{'is-loading': loadingForm}">Cancelar</button>
        <button class="button is-primary is-medium" :class="{'is-loading': loadingForm}"
                @click="enviarProspect">
          <b-icon icon="check"></b-icon>
          <span>Salvar</span>
        </button>
      </footer>

    </portal-box>
  </section>
</template>

<script>
  import moment from 'moment'
  import {mask} from 'vue-the-mask'

  export default {
    directives: {mask},
    mounted () {
      let possuiPermissao
      this.$store.state.menu.forEach(item => {
        if (item.sub_menus.filter(sub => sub.link === '/cliente/novo').length > 0) {
          possuiPermissao = true
        }
      })
      if (!possuiPermissao) {
        this.$router.push('/403')
      }
      this.$refs.cnpj.focus()
    },
    data () {
//      const today = new Date()
      return {
        loadingForm: false,
        prospect: this.novoProspect(),
        loadingCondicaoPagamento: false,
        condicaoSelecionada: null,
        condicoesPagamento: [],
        porcentagem: {
          decimal: '.',
          thousands: '',
          prefix: '',
          suffix: '%',
          precision: 2,
          masked: false
        },
        estados: ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MS', 'MT', 'MG', 'PA', 'PB', 'PR',
          'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO']
      }
    },
    methods: {
      novoProspect () {
        return {
          DATA_CADASTRO: new Date(),
          CNPJ: '',
          RAZAO: '',
          FANTASIA: '',
          INSC_ESTADUAL: '',
          SUFRAMA: '',
          DDD: '',
          TEL: '',
          EMAIL: '',
          CONTATO: '',
          CEP: '',
          ENDERECO: '',
          BAIRRO: '',
          CIDADE: '',
          ESTADO: '',
          REF1: '',
          TELREF1: '',
          DDDREF1: '',
          REF2: '',
          DDDREF2: '',
          TELREF2: '',
          REF3: '',
          DDDREF3: '',
          TELREF3: '',
          TRANSFERIDO: 'N'
        }
      },
      enviarProspect () {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.$dialog.confirm({
              message: 'Deseja realmente enviar o prospect?',
              cancelText: 'Não',
              confirmText: 'Sim, Enviar!',
              hasIcon: true,
              type: 'is-info',
              onConfirm: () => {
                let prospecto = this.$clonar(this.prospect)
                prospecto.DATA_CADASTRO = moment(prospecto.DATA_CADASTRO)
                prospecto.CNPJ = prospecto.CNPJ.replace(/[^0-9]/g, '')
                prospecto.CEP = prospecto.CEP.replace(/[^0-9]/g, '')
                prospecto.DDD = this.somenteDDD(prospecto.TEL)
                prospecto.TEL = this.somenteTelefone(prospecto.TEL)
                prospecto.DDDREF1 = this.somenteDDD(prospecto.TELREF1)
                prospecto.TELREF1 = this.somenteTelefone(prospecto.TELREF1)
                prospecto.DDDREF2 = this.somenteDDD(prospecto.TELREF2)
                prospecto.TELREF2 = this.somenteTelefone(prospecto.TELREF2)
                prospecto.DDDREF3 = this.somenteDDD(prospecto.TELREF3)
                prospecto.TELREF3 = this.somenteTelefone(prospecto.TELREF3)
                this.loadingForm = true
                this.$http.post(this.$URL.PROSPECT.BASE, prospecto, this.$header())
                  .then(res => this.mensagemSucessoForm(), res => this.mensagemFalhaProspect(res)
                  )
              }
            })
          }
        })
      },
      somenteTelefone (numero) {
        numero = numero.replace(/[^0-9]/g, '')
        return numero.slice(2, numero.length)
      },
      somenteDDD (numero) {
        numero = numero.replace(/[^0-9]/g, '')
        return numero.slice(0, 2)
      },
      cancelar () {
        this.$dialog.confirm({
          message: 'O prospect ainda não foi salvo, Deseja realmente cancelar?',
          cancelText: 'Não',
          confirmText: 'Sim, Cancelar!',
          hasIcon: true,
          type: 'is-danger',
          onConfirm: () => {
            this.loadingForm = false
            this.limparFormulario()
          }
        })
      },
      toast (res) {
        let msg = res.body.message
        let tipo
        switch (res.status) {
          case 0:
          case 404:
            tipo = 'is-warning'
            msg = 'Ops! Nosso servidor está offline, tente novamente mais tarde.'
            break
          case 422:
          case 500:
            tipo = 'is-danger'
            break
          case 200:
            tipo = 'is-info'
            break
          case 201:
            tipo = 'is-success'
            break
        }
        this.$toast.open({
          message: msg,
          type: tipo,
          duration: 7 * 1000
        })
      },
      mensagemSucessoForm () {
        this.loadingForm = false
        this.$dialog.alert({
          title: 'Prospect salvo com sucesso!',
          message: 'O prospect foi criado com sucesso </br> e aguarda a criação de um orçamento para ser enviado a fábrica. ',
          type: 'is-success',
          hasIcon: true,
          icon: 'check',
          onConfirm: () => {
            this.loadingForm = false
            this.limparFormulario()
          }
        })
      },
      limparFormulario () {
        this.prospect = this.novoProspect()
        this.condicaoSelecionada = null
        this.$validator.reset()
      },
      mensagemFalhaProspect (res) {
        let listaErro = '<ul>'
        let erros = res.body
        Object.keys(erros).forEach(function (erro) {
          erros[erro].forEach(msg => {
            listaErro += '<li class="has-text-danger"><span>' + msg + '</span></li>'
          })
          listaErro += '</ul>'
        })
        this.loadingForm = false
        this.$dialog.alert({
          title: 'Erro',
          message: listaErro,
          type: 'is-danger',
          hasIcon: false
        })
      }
    },
    watch: {
      'prospect.RAZAO' (value) {
        if (!value) return ''
        value = value.toLocaleUpperCase()
        this.$refs.razao.$emit('input', value)
      },
      'prospect.FANTASIA' (value) {
        if (!value) return ''
        value = value.toLocaleUpperCase()
        this.$refs.fantasia.$emit('input', value)
      },
      'prospect.INSC_ESTADUAL' (value) {
        if (!value) return ''
        value = value.toLocaleUpperCase()
        this.$refs.inscEstadual.$emit('input', value)
      },
      'prospect.SUFRAMA' (value) {
        if (!value) return ''
        value = value.toLocaleUpperCase()
        this.$refs.suframa.$emit('input', value)
      },
      'prospect.CONTATO' (value) {
        if (!value) return ''
        value = value.toLocaleUpperCase()
        this.$refs.contato.$emit('input', value)
      },
      'prospect.ENDERECO' (value) {
        if (!value) return ''
        value = value.toLocaleUpperCase()
        this.$refs.endereco.$emit('input', value)
      },
      'prospect.BAIRRO' (value) {
        if (!value) return ''
        value = value.toLocaleUpperCase()
        this.$refs.bairro.$emit('input', value)
      },
      'prospect.CIDADE' (value) {
        if (!value) return ''
        value = value.toLocaleUpperCase()
        this.$refs.cidade.$emit('input', value)
      },
      'prospect.REF1' (value) {
        if (!value) return ''
        value = value.toLocaleUpperCase()
        this.$refs.ref1.$emit('input', value)
      },
      'prospect.REF2' (value) {
        if (!value) return ''
        value = value.toLocaleUpperCase()
        this.$refs.ref2.$emit('input', value)
      },
      'prospect.REF3' (value) {
        if (!value) return ''
        value = value.toLocaleUpperCase()
        this.$refs.ref3.$emit('input', value)
      }
    },
    computed: {
      parametros () {
        return this.$store.state.parametros
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/cliente/ProspectPiller.vue